import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { IconButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Modal, ModalTypes } from '@eika/modal';
const HelpModal = _ref => {
  let {
    helpText,
    questionId,
    className
  } = _ref;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const showModal = e => {
    e.preventDefault();
    setIsModalOpen(true);
  };
  if (helpText == null || helpText === '') {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    className: className !== null && className !== void 0 ? className : 'right',
    onClick: showModal,
    icon: IconTypes.INFO_20,
    id: "help-icon-".concat(questionId),
    screenReaderText: "Hjelpetekst"
  }), /*#__PURE__*/React.createElement(Modal, {
    onClose: closeModal,
    show: isModalOpen,
    id: "helpermodal__modal",
    type: ModalTypes.STANDARD,
    appNamespace: "kyc-declaration.app"
  }, /*#__PURE__*/React.createElement("div", {
    role: "tooltip",
    id: "helpermodal"
  }, helpText && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: helpText
    }
  }), /*#__PURE__*/React.createElement(StandardButton, {
    className: "help-modal-button",
    onClick: closeModal
  }, "Lukk"))));
};
export default HelpModal;